import { useMutation } from '@apollo/client';
import { UPDATE_CUSTOM_STAGE_TASK_DETAILS } from '@frontend/app/queries/UpdateCustomStageTaskDetails';
import type {
  UpdateCustomStageTaskDetails,
  UpdateCustomStageTaskDetailsVariables
} from '@frontend/app/queries/types/UpdateCustomStageTaskDetails';

export const useUpdateCustomStageTaskDetails = () => {
  const [updateCustomStageTaskDetails, { loading, error }] = useMutation<
    UpdateCustomStageTaskDetails,
    UpdateCustomStageTaskDetailsVariables
  >(UPDATE_CUSTOM_STAGE_TASK_DETAILS);

  const updateStageTaskDetails = async (variables: UpdateCustomStageTaskDetailsVariables, onSuccess?: () => void) => {
    const result = await updateCustomStageTaskDetails({
      variables,
    });

    // Call the success callback if provided
    if (onSuccess) {
      onSuccess();
    }

    return result.data;
  };

  return {
    updateStageTaskDetails,
    loading,
    error
  };
};
